import React from "react";
import RabbitIllustrations from "../../components/RabbitNameGenerator/RabbitIllustrations";
import RabbitNameGenerator from "../../components/RabbitNameGenerator";
import CatIllustrations from "../../components/RabbitNameGenerator/CatIllustrations";

const HomePage = () => {
  return (
    <div>
      {/* <RabbitIllustrations /> */}
      <CatIllustrations/>
      <RabbitNameGenerator />
    </div>
  );
};

export default HomePage;
